export default __webpack_public_path__ + "static/media/paralax1.9842c5f1.jpg";